import React from 'react';
import { ReactComponent as ChatBotLogo } from '../../../assets/images/chatbot.svg';
import './style.css';

function TeamChatBot() {
  return (
    <div style={{ height: '60vh' }} className="TeamChatBot-Main-Container">
      <ChatBotLogo />
      <p className="Chatbot-devploment">Under Development</p>
      <p className="Chatbot-crafting">Our chatbot is currently in the development phase.</p>
    </div>
  );
}

export default TeamChatBot;
